import React from 'react'
import styled from 'styled-components'
import {HOST_ACCOUNT_HOLDER_MAX_LENGTH, WINDOW_MODE_TABLET_WIDTH} from 'consts'
import {useTranslation} from 'i18n'
import {Icon, Input} from 'common/components'
import {VALIDATION_TREE_HOST_ACCOUNT_HOLDER} from 'common/validations'
import convertUnit from 'lib/unit'
import {TreeRegistrationFormItemProps} from './TreeRegistrationFormItemProps'

const StyledLeftItemsContainer = styled.div`
  margin-top: ${convertUnit(20)};
  width: 50%;
  margin-right: ${convertUnit(40)};
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    margin-right: 0;
    width: 100%;
  }
`

export default function TreeRegistrationFormItemAccountHolder({
  disabled,
  form,
}: TreeRegistrationFormItemProps) {
  const {translate} = useTranslation()
  const {watch, setValue} = form
  const {accountHolder} = watch()

  return (
    <StyledLeftItemsContainer>
      <Input
        form={form}
        formRules={VALIDATION_TREE_HOST_ACCOUNT_HOLDER}
        name="accountHolder"
        label={translate('tree:hostRegistrationFormAccountHolderLabel')}
        placeholder={translate(
          'tree:hostRegistrationFormAccountHolderPlaceholder',
        )}
        maxLength={HOST_ACCOUNT_HOLDER_MAX_LENGTH}
        disabled={disabled}
        rightIcon={
          !disabled && accountHolder && accountHolder.length > 0 ? (
            <Icon
              type="close"
              size={convertUnit(16)}
              onClick={() => setValue('addressNumber', '')}
            />
          ) : undefined
        }
      />
    </StyledLeftItemsContainer>
  )
}
